const MAX_LISTINGS = 5;

export default {
    SET_LISTING: (state, {
        key,
        products,
        pageNumber,
        hasMoreProducts,
        scrollY,
    }) => {
        const listings = {};

        Object.keys(state.listings)
            .filter((otherKey) => otherKey !== key)
            .sort((a, b) => state.listings[b].savedAt - state.listings[a].savedAt)
            .slice(0, MAX_LISTINGS - 1)
            .forEach((otherKey) => {
                listings[otherKey] = state.listings[otherKey];
            });

        // Frozen so Vue does not walk hundreds of products a second time.
        listings[key] = Object.freeze({
            products: Object.freeze([...products]),
            pageNumber,
            hasMoreProducts,
            scrollY,
            savedAt: Date.now(),
        });

        state.listings = listings;
    },
};
